import { render, staticRenderFns } from "./Button2.vue?vue&type=template&id=4d5bccd5&scoped=true&"
import script from "./Button2.vue?vue&type=script&lang=js&"
export * from "./Button2.vue?vue&type=script&lang=js&"
import style0 from "./Button2.vue?vue&type=style&index=0&id=4d5bccd5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5bccd5",
  null
  
)

export default component.exports